// Mobile Card Scroller Auto-Rotate Functionality
(function() {
  'use strict';
  
  function initMobileAutoRotate() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileAutoRotate);
      return;
    }
    
    console.log('Initializing mobile auto-rotate...');
    
    // Find all mobile card scrollers with auto-rotate enabled
    const scrollers = document.querySelectorAll('.mobile-card-scroller[data-auto-rotate="true"]');
    console.log('Found', scrollers.length, 'auto-rotate scrollers');
    
    scrollers.forEach((scroller, index) => {
      console.log('Processing scroller', index);
      
      // Only run on mobile
      if (window.innerWidth > 749) {
        console.log('Skipping - not mobile screen');
        return;
      }
      
      const speed = parseInt(scroller.getAttribute('data-rotate-speed')) || 4000;
      const children = scroller.children;
      
      console.log('Scroller has', children.length, 'children, speed:', speed);
      
      if (children.length <= 1) return;
      
      let currentIndex = 0;
      let isRotating = true;
      let rotateInterval;
      
      function rotateNext() {
        if (!isRotating) return;
        
        currentIndex = (currentIndex + 1) % children.length;
        const scrollWidth = scroller.scrollWidth / children.length;
        const scrollLeft = currentIndex * scrollWidth;
        
        console.log('Rotating to index', currentIndex, 'scrollLeft:', scrollLeft);
        
        scroller.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
      
      function pauseRotation() {
        isRotating = false;
        console.log('Paused rotation');
      }
      
      function resumeRotation() {
        isRotating = true;
        console.log('Resumed rotation');
      }
      
      // Start rotation
      console.log('Starting rotation interval');
      rotateInterval = setInterval(rotateNext, speed);
      
      // Pause on interaction
      scroller.addEventListener('touchstart', pauseRotation);
      scroller.addEventListener('mousedown', pauseRotation); // For desktop testing
      
      scroller.addEventListener('touchend', () => {
        setTimeout(resumeRotation, 2000);
      });
      
      scroller.addEventListener('mouseup', () => {
        setTimeout(resumeRotation, 2000);
      });
      
      // Pause on manual scroll
      let scrollTimeout;
      scroller.addEventListener('scroll', () => {
        pauseRotation();
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(resumeRotation, 3000);
      });
      
      // Handle visibility change (pause when tab not active)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          pauseRotation();
        } else {
          resumeRotation();
        }
      });
      
      // Store for cleanup
      scroller._rotateInterval = rotateInterval;
    });
    
    // Re-initialize on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Clear existing intervals
        document.querySelectorAll('.mobile-card-scroller').forEach(scroller => {
          if (scroller._rotateInterval) {
            clearInterval(scroller._rotateInterval);
            scroller._rotateInterval = null;
          }
        });
        // Re-initialize
        initMobileAutoRotate();
      }, 250);
    });
  }
  
  // Initialize immediately or when DOM is ready
  initMobileAutoRotate();
  
})();
